import { Injectable } from '@angular/core';
import {WorksState, WorksStore} from './works.store';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import {JsonApiEntityService} from '../jsonentity/json-api-entity.service';

@Injectable({ providedIn: 'root' })
export class WorksService extends JsonApiEntityService<WorksState> {

  constructor(private worksStore: WorksStore) {
    super(worksStore);
  }
}
